import React, { useEffect, useState } from "react";
import * as Sentry from '@sentry/react';
// Styles
import "jquery/dist/jquery.min.js";
import "bootstrap/scss/bootstrap";
import "bootstrap/dist/js/bootstrap.min.js";
import "antd/dist/antd.css";
import "../stylesheet/App";
import {
  setCurrentUser,
  logoutUser,
} from "../redux/Actions/authAction";
import jwt_decode from "jwt-decode";
import { Provider } from "react-redux";
import store from "../helpers/store";

import Axios from "axios";
import Routes from "./Routes";

function Index() {
  const [loading, setLoading] = useState(true);

  const localStorageAction = async () => {
    const tokeneLS = localStorage.getItem("trToken");

    try {
      if (tokeneLS) {
        const decoded = jwt_decode(localStorage.trToken);

        // Timeout
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
          return store.dispatch(logoutUser());
        }
        //
        const { data, status } = await Axios.get("/api/v1/logged_in_user");
        if (status == 302) {
          return store.dispatch(logoutUser());
        }
        if (data) {
          if (!data.id) {
            return store.dispatch(logoutUser());
          }
          setLoading(false);

          let object = {
            ...decoded,
            ...data,
          };
          store.dispatch(setCurrentUser(object));
        }
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.log("Error Index", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    localStorageAction();
  }, []);

  return (
    <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>} showDialog>
      <Provider store={store}>
        <Routes loading={loading} />
      </Provider>
    </Sentry.ErrorBoundary>
  );
}

export default Index;
